document.addEventListener('DOMContentLoaded', async () => {
  const layout = document.querySelector('.form-selector-layout');
  if (!layout) return;

  const csvUrl = layout.dataset.vehicleList;
  const desktopContainer = document.querySelector('.vehicle-selector-bar__form.desktop-only');
  const mobileContainer = document.querySelector('.mobile-popup-content');
  const popupTrigger = document.querySelector('.vehicle-popup-trigger');
  const popupOverlay = document.querySelector('.vehicle-popup-overlay');
  const popupClose = document.querySelector('.vehicle-popup-close');

  /* ------------------ FORM TEMPLATE ------------------ */
  const createForm = () => `
    <div class="dropdown-wrapper">
      <select class="makeSelect custom-dropdown">
        <option value="">Select Make</option>
      </select>
    </div>

    <div class="dropdown-wrapper">
      <select class="modelSelect custom-dropdown" disabled>
        <option value="">Select Model</option>
      </select>
    </div>

    <div class="button-wrapper">
      <button type="button" disabled class="vehicleSearchBtn vehicle-btn shop-btn">
        Search
      </button>
      <button type="button" disabled class="vehicleResetBtn vehicle-btn shop-btn">
        Reset
      </button>
    </div>
  `;

  desktopContainer.innerHTML = createForm();
  mobileContainer.innerHTML = createForm();

  const getElements = (container) => ({
    make: container.querySelector('.makeSelect'),
    model: container.querySelector('.modelSelect'),
    search: container.querySelector('.vehicleSearchBtn'),
    reset: container.querySelector('.vehicleResetBtn')
  });

  const desktop = getElements(desktopContainer);
  const mobile = getElements(mobileContainer);

  /* ------------------ CSV PARSER ------------------ */
  const parseCSV = (text) => {
    text = text.replace(/^\uFEFF/, '').trim();
    const lines = text.split(/\r?\n/).filter(Boolean);
    const delimiter =
      lines[0].includes('\t') ? '\t' :
      lines[0].includes(';') ? ';' : ',';

    return lines.map(line =>
      line.split(delimiter).map(cell =>
        cell.trim().replace(/^"|"$/g, '')
      )
    );
  };

  /* ------------------ FETCH VEHICLE CSV ------------------ */
  const fetchVehicleData = async () => {
    const res = await fetch(csvUrl);
    const text = await res.text();

    const rows = parseCSV(text);
    const header = rows.shift().map(h => h.toLowerCase());

    const makeIndex = header.indexOf('make');
    const modelIndex = header.indexOf('model');

    if (makeIndex < 0 || modelIndex < 0) {
      console.error('CSV must contain Make and Model columns');
      return {};
    }

    const data = {};
    rows.forEach(row => {
      const make = row[makeIndex];
      const model = row[modelIndex];
      if (!make || !model) return;

      data[make] ??= [];
      if (!data[make].includes(model)) {
        data[make].push(model);
      }
    });

    return data;
  };

  const vehicleData = await fetchVehicleData();

  /* ------------------ FORM LOGIC ------------------ */
  const setupLogic = (el) => {
    // Populate makes
    el.make.innerHTML = '<option value="">Select Make</option>';
    Object.keys(vehicleData).sort().forEach(make =>
      el.make.add(new Option(make, make))
    );

    // Make change
    el.make.addEventListener('change', () => {
      el.model.innerHTML = '<option value="">Select Model</option>';
      el.model.disabled = true;
      el.search.disabled = true;
      el.reset.disabled = false;

      const models = vehicleData[el.make.value] || [];
      models.sort().forEach(model =>
        el.model.add(new Option(model, model))
      );

      if (models.length) el.model.disabled = false;
    });

    // Model change
    el.model.addEventListener('change', () => {
      el.search.disabled = !el.model.value;
    });

    // 🔍 SEARCH → REDIRECT
    el.search.addEventListener('click', () => {
      const make = el.make.value;
      const model = el.model.value;
      if (!make || !model) return;

      const query = encodeURIComponent(`${make} ${model}`);
      window.location.href = `/search?q=${query}&type=product`;
    });

    // 🔄 RESET → PAGE RELOAD
    el.reset.addEventListener('click', () => {
      window.location.href = window.location.pathname;
    });
  };

  setupLogic(desktop);
  setupLogic(mobile);

  /* ------------------ POPUP (MOBILE) ------------------ */
  if (popupTrigger && popupOverlay && popupClose) {
    popupTrigger.onclick = () => {
      popupOverlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    };

    popupClose.onclick = () => {
      popupOverlay.classList.remove('active');
      document.body.style.overflow = '';
    };

    popupOverlay.onclick = (e) => {
      if (e.target === popupOverlay) popupClose.click();
    };
  }
});
